import client from './Client';
// // src/api/Submission.js

// const BASE_URL = process.env.REACT_APP_API_URL;

// export const submissionsApi = {
//   // User Access APIs
//   async createUserAccess(data) {
//     const response = await fetch(`${BASE_URL}/api/v1/create-user-access`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });
//     return response;
//   },

//   async getUserAccess(params = {}) {
//     try {
//       const queryParams = new URLSearchParams();
      
//       // Add base params
//       if (params.limit) {
//         queryParams.append('limit', params.limit);
//       }
      
//       // Add pagination
//       if (params.last_evaluated_key) {
//         queryParams.append('last_evaluated_key', params.last_evaluated_key);
//       }
      
//       // Add status filter
//       if (params.status) {
//         queryParams.append('status', params.status);
//       }
  
//       const response = await fetch(`${BASE_URL}/api/v1/user-access?${queryParams}`);
      
//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.detail || 'Failed to fetch user access data');
//       }
//       return response.json();
//     } catch (error) {
//       console.error('Error in getUserAccess:', error);
//       throw error;
//     }
//   },
  
//   async performUserAccessAction(action, id) {
//     const validActions = ['approve', 'reject', 'revoke'];
//     if (!validActions.includes(action)) {
//       throw new Error('Invalid action');
//     }
  
//     try {
//       const response = await fetch(`${BASE_URL}/api/v1/${action}-user-access`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id })
//       });
  
//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.detail || `Failed to ${action} user access`);
//       }
//       return response.json();
//     } catch (error) {
//       console.error(`Error in ${action}UserAccess:`, error);
//       throw error;
//     }
//   },

//   async approveUserAccess(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/approve-user-access`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id })
//     });
//     if (!response.ok) throw new Error('Failed to approve user access');
//     return response.json();
//   },

//   async rejectUserAccess(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/reject-user-access`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id })
//     });
//     if (!response.ok) throw new Error('Failed to reject user access');
//     return response.json();
//   },

//   async revokeUserAccess(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/revoke-user-access`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id })
//     });
//     if (!response.ok) throw new Error('Failed to revoke user access');
//     return response.json();
//   },

//   // External Accounts APIs
  
//   async getExternalAccountsPaginated(params = {}) {
//     const queryParams = new URLSearchParams(params);
//     const response = await fetch(`${BASE_URL}/api/v1/list-external-accounts?${queryParams}`);
//     if (!response.ok) throw new Error('Ffailed to get external accounts');
//     return response.json();
//   },

//   async getExternalAccounts(params = {}) {
//     const queryParams = new URLSearchParams(params);
//     const response = await fetch(`${BASE_URL}/api/v1/external-accounts?${queryParams}`);
//     if (!response.ok) throw new Error('Ffailed to get external accounts');
//     return response.json();
//   },

//   async getExternalAccount(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/external-accounts/${id}`);
//     if (!response.ok) throw new Error('Failed to get external account');
//     return response.json();
//   },

//   async createExternalAccount(data) {
//     const response = await fetch(`${BASE_URL}/api/v1/external-accounts`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });
//     if (!response.ok) throw new Error('Failed to create external account');
//     return response.json();
//   },

//   async updateExternalAccount(id, data) {
//     const response = await fetch(`${BASE_URL}/api/v1/external-accounts/${id}`, {
//       method: 'PUT',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });
//     if (!response.ok) throw new Error('Failed to update external account');
//     return response.json();
//   },

//   async updateExternalAccountStatus(data) {
//     const response = await fetch(`${BASE_URL}/api/v1/external-accounts/status`, {
//       method: 'PUT',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });
//     if (!response.ok) throw new Error('Failed to update account status');
//     return response.json();
//   },

//   // Policies APIs
//   async getPolicies(params = {}) {
//     const queryParams = new URLSearchParams(params);
//     const response = await fetch(`${BASE_URL}/api/v1/policies?${queryParams}`);
//     if (!response.ok) throw new Error('Failed to get policies');
//     return response.json();
//   },

//   // Frameworks APIs
//   async getAllFrameworks() {
//     const response = await fetch(`${BASE_URL}/api/v1/frameworks`);
//     if (!response.ok) throw new Error('Failed to get frameworks');
//     return response.json();
//   },

//   // Indicators APIs
//   async getIndicators(applicationId) {
//     const response = await fetch(`${BASE_URL}/api/v1/indicators/${applicationId}`);
//     if (!response.ok) throw new Error('Failed to get indicators');
//     return response.json();
//   },

//   // Indicator Submissions APIs
//   async getIndicatorSubmission(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/indicator-submissions/${id}`);
//     if (!response.ok) throw new Error('Failed to get indicator submission');
//     return response.json();
//   },

//   async createSubmission(data) {
//     const response = await fetch(`${BASE_URL}/api/v1/submissions`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });
//     if (!response.ok) throw new Error('Failed to create submission');
//     return response.json();
//   },

//   async updateIndicatorText(id, text) {
//     const response = await fetch(`${BASE_URL}/api/v1/indicator-submissions/${id}/text`, {
//       method: 'PUT',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ text })
//     });
//     if (!response.ok) throw new Error('Failed to update indicator text');
//     return response.json();
//   },

//   async getAgentSubmissionRecommendation(id) {
//     const response = await fetch(`${BASE_URL}/api/v1/indicator-submissions/${id}/recommendations`);
//     if (!response.ok) throw new Error('Failed to get submission recommendations');
//     return response.json();
//   },

//   // File Upload APIs
//   async generateUploadUrl(submissionId) {
//     const response = await fetch(`${BASE_URL}/api/v1/generate-upload-url`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ submission_id: submissionId })
//     });
//     if (!response.ok) throw new Error('Failed to generate upload URL');
//     return response.json();
//   },

//   async markUploadComplete(uploadId) {
//     const response = await fetch(`${BASE_URL}/api/v1/complete-upload`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ upload_id: uploadId })
//     });
//     if (!response.ok) throw new Error('Failed to mark upload as complete');
//     return response.json();
//   },

//   async deleteUploadedFile(fileId) {
//     const response = await fetch(`${BASE_URL}/api/v1/uploaded-files/${fileId}`, {
//       method: 'DELETE'
//     });
//     if (!response.ok) throw new Error('Failed to delete uploaded file');
//     return response.json();
//   },

//   // AI Check API
//   async invokeAiCheck(submissionId) {
//     const response = await fetch(`${BASE_URL}/api/v1/indicator-submissions/${submissionId}/ai-check`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' }
//     });
//     if (!response.ok) throw new Error('Failed to invoke AI check');
//     return response.json();
//   }
// };



const BASE_URL = '/api/v1';

export const submissionsApi = {
  async createUserAccess(data) {
    return client.post(`${BASE_URL}/create-user-access`, data);
  },
  async listMyRequests(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.last_evaluated_key) queryParams.append('last_evaluated_key', params.last_evaluated_key);
    if (params.status) queryParams.append('status', params.status);
    return client.get(`${BASE_URL}/list-my-user-requests?${queryParams}`);
  },
  async getUserAccessDetails(id) {
    return client.get(`${BASE_URL}/user-access/${id}`);
  },

  async getUserAccess(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.last_evaluated_key) queryParams.append('last_evaluated_key', params.last_evaluated_key);
    if (params.status) queryParams.append('status', params.status);
    return client.get(`${BASE_URL}/user-access?${queryParams}`);
  },

  async performUserAccessAction(action, id, options = {}) {
    if (!['cancel', 'approve', 'reject', 'revoke'].includes(action)) throw new Error('Invalid action');
    const payload = { id };
    if (action === 'approve' && options.deny_delete !== undefined) {
      payload.deny_delete = options.deny_delete;
    }
    return client.post(`${BASE_URL}/${action}-user-access`, payload);
  },

  async approveUserAccess(id, deny_delete) {
    const payload = { id };
    if (deny_delete !== undefined) {
      payload.deny_delete = deny_delete;
    }
    return client.post(`${BASE_URL}/approve-user-access`, payload);
  },

  async rejectUserAccess(id) {
    return client.post(`${BASE_URL}/reject-user-access`, { id });
  },

  async revokeUserAccess(id) {
    return client.post(`${BASE_URL}/revoke-user-access`, { id });
  },

  async getExternalAccountsPaginated(params = {}) {
    const queryParams = new URLSearchParams(params);
    return client.get(`${BASE_URL}/list-external-accounts?${queryParams}`);
  },

  async getExternalAccounts(params = {}) {
    const queryParams = new URLSearchParams(params);
    return client.get(`${BASE_URL}/external-accounts?${queryParams}`);
  },

  async getExternalAccount(id) {
    return client.get(`${BASE_URL}/external-accounts/${id}`);
  },

  async createExternalAccount(data) {
    return client.post(`${BASE_URL}/external-accounts`, data);
  },

  async updateExternalAccount(id, data) {
    return client.put(`${BASE_URL}/external-accounts/${id}`, data);
  },

  async updateExternalAccountStatus(data) {
    return client.put(`${BASE_URL}/external-accounts/status`, data);
  },

  async getPolicies(params = {}) {
    const queryParams = new URLSearchParams(params);
    return client.get(`${BASE_URL}/policies?${queryParams}`);
  },

  async getAllFrameworks() {
    return client.get(`${BASE_URL}/frameworks`);
  },

  async getIndicators(applicationId) {
    return client.get(`${BASE_URL}/indicators/${applicationId}`);
  },

  async getIndicatorSubmission(id) {
    return client.get(`${BASE_URL}/indicator-submissions/${id}`);
  },

  async createSubmission(data) {
    return client.post(`${BASE_URL}/submissions`, data);
  },

  async updateIndicatorText(id, text) {
    return client.put(`${BASE_URL}/indicator-submissions/${id}/text`, { text });
  },

  async getAgentSubmissionRecommendation(id) {
    return client.get(`${BASE_URL}/indicator-submissions/${id}/recommendations`);
  },

  async generateUploadUrl(submissionId) {
    return client.post(`${BASE_URL}/generate-upload-url`, { submission_id: submissionId });
  },

  async markUploadComplete(uploadId) {
    return client.post(`${BASE_URL}/complete-upload`, { upload_id: uploadId });
  },

  async deleteUploadedFile(fileId) {
    return client.delete(`${BASE_URL}/uploaded-files/${fileId}`);
  },

  async invokeAiCheck(submissionId) {
    return client.post(`${BASE_URL}/indicator-submissions/${submissionId}/ai-check`);
  }

  
};
